import { apiAxios } from '../../../helpers'

export const getList = async (commit, idStadium) => {
  if (!idStadium) return
  commit('updateLoading', true)
  let result = await apiAxios
    .get('stadiums/' + idStadium + '/pitches/')
    .finally(_ => commit('updateLoading', false))
  commit('updateList', result.data.data.pitches)
}

export const getOne = async (commit, idStadium, idPitch) => {
  if (!idStadium || !idPitch) return
  commit('updateLoading', true)

  let result = await apiAxios
    .get('stadiums/' + idStadium + '/pitches/' + idPitch)
    .finally(_ => commit('updateLoading', false))
  commit('updateOne', result.data.data.pitch)
}

export const getPortion = async (commit, arrayStadium) => {
  if (!arrayStadium) return
  commit('clearPortion')
  commit('updateLoading', true)
  await arrayStadium.forEach(async item => {
    let result = await apiAxios
      .get('stadiums/' + item + '/pitches/')
      .finally(_ => commit('updateLoading', false))
    commit('updatePortion', result.data.data.pitches)
  })
}
